import React, { useEffect, useState } from 'react';
import {
  Button,
  Text,
  Icon,
  VStack,
  Dialog,
  Portal,
} from '@chakra-ui/react';
import { FaLock, FaBolt } from 'react-icons/fa';

/**
 * Muestra un pop-up cuando el backend responde con un error de plan:
 * - PLAN_LIMIT_EXCEEDED: se agotó el presupuesto del ciclo (bloqueo real).
 * - PLAN_QUOTA_EXCEEDED: se alcanzó una cuota (obras, páginas o almacenamiento).
 * - FEATURE_NOT_IN_PLAN: la funcionalidad no está incluida en el plan.
 * Se dispara vía el evento global 'cadencya:plan-error' emitido por el
 * interceptor de axios en services/api.js.
 */
const PlanErrorModal = () => {
  const [state, setState] = useState(null);

  useEffect(() => {
    const handler = (e) => setState(e.detail || null);
    window.addEventListener('cadencya:plan-error', handler);
    return () => window.removeEventListener('cadencya:plan-error', handler);
  }, []);

  const onClose = () => setState(null);
  const isLimit =
    state?.code === 'PLAN_LIMIT_EXCEEDED' || state?.code === 'PLAN_QUOTA_EXCEEDED';
  const data = state?.data || {};

  const title = isLimit
    ? 'Has alcanzado el límite de tu plan'
    : 'Funcionalidad no incluida en tu plan';

  const message =
    data.message ||
    (state?.code === 'PLAN_QUOTA_EXCEEDED'
      ? 'Has alcanzado el límite de tu plan para esta acción. Mejora tu plan o elimina elementos del archivo.'
      : isLimit
        ? 'Has alcanzado el límite de consumo de tu plan. El servicio se reanudará en la próxima renovación de tu suscripción o al ampliar tu plan.'
        : 'Esta funcionalidad no está incluida en tu plan actual. Mejora tu plan para acceder.');

  return (
    <Dialog.Root open={!!state} placement='center' onOpenChange={e => {
      if (!e.open) {
        onClose();
      }
    }}>
      <Portal>

        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <VStack align="start" gap={2}>
                <Icon
                  as={isLimit ? FaBolt : FaLock}
                  boxSize={6}
                  color={isLimit ? 'orange.400' : 'purple.500'}
                />
                <Text>{title}</Text>
              </VStack>
            </Dialog.Header>
            <Dialog.CloseTrigger />
            <Dialog.Body>
              <Text color="gray.600">{message}</Text>
              {state?.code === 'PLAN_LIMIT_EXCEEDED' && data.budgetEur != null && (
                <Text fontSize="sm" color="gray.500" mt={3}>
                  Consumo del mes: {Number(data.totalEur || 0).toFixed(2)} € de{' '}
                  {Number(data.budgetEur || 0).toFixed(2)} €.
                </Text>
              )}
            </Dialog.Body>
            <Dialog.Footer>
              <Button colorPalette="purple" onClick={onClose}>
                Entendido
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>

      </Portal>
    </Dialog.Root>
  );
};

export default PlanErrorModal;
